import { Component, Prop, Vue } from 'vue-property-decorator'
import Field from '@/shared/classes/form/field'
import FormBase from '@/shared/classes/form/form-base'
import { IFieldError } from '@/shared/interfaces/classes/form.interfaces'
import _ from 'lodash'
import { LOCALE_ERROR } from '@/shared/constants/locales.constants'
import { FieldTypes } from "@/shared/components/form/field-types";

@Component
export default class AbstractField extends Vue {
  @Prop() field!: Field|any
  @Prop() fullKey!: string
  @Prop() form!: FormBase
  @Prop() index!: number

  get value() {
    if (this.form && ! this.form.withoutData) {
      return _.get(this.form.data, this.fullKey)
    }

    return this.field.value
  }

  set value(value) {
    if (this.field.beforeChange) value = this.field.beforeChange(value)
    if (this.form && ! this.form.withoutData) {
      _.set(this.form.data, this.fullKey, value)
      if (this.field.onChange && this.field.type !== FieldTypes.datePicker) this.field.onChange(value, this.fullKey)
      return
    }

    this.field.value = value
    if (this.field.onChange && this.field.type !== FieldTypes.datePicker) this.field.onChange(value, this.fullKey)
  }

  getError(): IFieldError|boolean|null {
    if (! this.form) return null
    return _.get(this.form.errors, this.fullKey, {
      has: false,
      count: 0,
      messages: []
    })
  }

  removeError() {
    if (! this.form) return null
    if (this.field.translatable) {
      _.set(this.form.errors, `${ LOCALE_ERROR }.${ this.form.currentLanguage }`, Object.keys(this.form.errors).some((key: string) => ! key.startsWith(LOCALE_ERROR) && key.endsWith(`.${ this.form.currentLanguage }`)))
    }

    delete this.form.errors[this.fullKey]
  }
}
